import { LANGUAGE_CODES, RECOVERY_PLAN_STATUS, VALIDATION_KEYS } from "@fysaro/shared";
import { z } from "zod";

export const upsertRecoveryPlanSchema = z.object({
  status: z.enum(RECOVERY_PLAN_STATUS).default("ACTIVE"),
  notes: z.string().optional().nullable(),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es").optional(),
  exercises: z.array(
    z.object({
      exerciseId: z.string().min(1, { message: VALIDATION_KEYS.PROTOCOL.INVALID_EXERCISE }),
      series: z.number().min(1, { message: VALIDATION_KEYS.PROTOCOL.SERIES_MIN_LENGTH }).default(3),
      repetitions: z.string().min(1, { message: VALIDATION_KEYS.PROTOCOL.REPS_REQUIRED }),
      restSeconds: z.number().nonnegative().default(60),
      frequency: z.string().min(1, { message: VALIDATION_KEYS.PROTOCOL.FREQUENCY_REQUIRED }),
      notes: z.string().optional().nullable(),
      order: z.number().int().nonnegative().default(0),

      // Snapshots (Opcionales desde el cliente, ya que el backend puede autocompletarlos leyendo el Exercise)
      exerciseTitleSnapshot: z.string().optional(),
      videoUrlSnapshot: z.string().optional().nullable(),
      thumbnailUrlSnapshot: z.string().optional().nullable(),
    })
  ).min(1, { message: VALIDATION_KEYS.PROTOCOL.EXERCISES_MIN_LENGTH }),
});